import styles from './ReserveNowPayLaterStrip.module.scss'

const ICON_BASE = `${window.staticPath}travel_dist/images/payment_icons`

const PAYMENT_ICONS = [
  { src: `${ICON_BASE}/visa.svg`, alt: 'Visa', className: styles.visaIcon },
  { src: `${ICON_BASE}/mastercard.svg`, alt: 'Mastercard', className: styles.mastercardIcon },
  { src: `${ICON_BASE}/american-express.svg`, alt: 'American Express', className: styles.amexIcon },
  { src: `${ICON_BASE}/apple-pay.svg`, alt: 'Apple Pay', className: styles.applePayIcon },
  { src: `${ICON_BASE}/google-pay.svg`, alt: 'Google Pay', className: styles.googlePayIcon },
]

export default function PaymentIconsRow() {
  return (
    <ul className={styles.paymentIcons}>
      {PAYMENT_ICONS.map(({ src, alt, className }) => (
        <li key={alt}>
          <img src={src} alt={alt} className={className} />
        </li>
      ))}
    </ul>
  )
}
